<template>
  <div
    :class="[
      'sidebar-management-custom',
      props.className,
      { 'is-collapsed': sidebarState.isCollapsed },
    ]"
    :style="[props.inlineStyles]"
  >
    <div class="sidebar-section">
      <div
        v-if="props.isShowLogo"
        class="is-logo"
        @click="
          () => {
            onClickLogo();
          }
        "
      >
        <img :src="props.logoImage" alt="Logo" />
      </div>
      <div
        v-if="props.isShowUsername && !sidebarState.isCollapsed"
        class="is-username pl-4 mb-8"
      >
        <span class="text-[#51307E] font-semibold text-xl">{{ props.userName }}</span>
      </div>


      <!-- Collapsed User Avatar -->
      <div
        class="flex justify-center mb-8"
        v-if="sidebarState.isCollapsed && props.userImage"
      >
        <img
          className="rounded-full border border-white box-sizing min-w-[2.5rem] max-w-[2.5rem] min-h-[2.5rem] max-h-[2.5rem]"
          :src="props.userImage"
          :title="props.userName"
        />
      </div>

      <div class="sidebar-lists flex flex-col gap-4">
        <div
          v-for="(menu, index) in props.menuList"
          class="flex space-x-2 justify-between items-center space-y-4"
          :key="index"
        >
          <div
            :class="[
              'button-box space-y-4 flex-1',
              {
                'is-selected':
                  menu.activeNameList.indexOf(
                    $router.currentRoute.value.name
                  ) >= 0 && !menu.subMenu,
                'is-active': sidebarState.expandedMenus[index],
                'is-collapsed': sidebarState.isCollapsed,
                'is-submenu-selected':
                  menu.subMenu &&
                  menu.subMenu.some(
                    sub =>
                      sub.activeNameList &&
                      sub.activeNameList.indexOf(
                        $router.currentRoute.value.name
                      ) >= 0
                  ),
              },
            ]"
            @click="
              () => {
                if (
                  !menu?.subMenu &&
                  $router.currentRoute.value.fullPath != menu.path &&
                  menu.path
                ) {
                  props.onClickSubMenu(index, false);
                  $router.push(menu.path);
                } else if (menu?.subMenu) {
                  toggleSubmenu(index);
                }
              }
            "
            :title="sidebarState.isCollapsed ? menu.name : ''"
          >
            <div
              v-if="!menu?.subMenu"
              :class="[
                'sidebar-button items-start flex text-white mb-4 mx-auto px-4 cursor-pointer',
                {
                  'rounded-[10px] text-[#64748b]': menu.isActive,
                  'justify-center': sidebarState.isCollapsed,
                },
              ]"
            >
              <div class="sidebar-image flex-none">
                <img
                  width="24"
                  height="24"
                  :src="menu.isActive ? menu.iconActive : menu.icon"
                  alt="Icon"
                />
              </div>
              <div
                v-if="!sidebarState.isCollapsed"
                :class="[
                  'sidebar-text flex-1 line-clamp-1',
                  { 'text-[#64748b]': menu.isActive },
                ]"
                :title="menu.name"
              >
                {{ menu.name }}
              </div>
            </div>
            <div v-else class="flex flex-col">
              <div
                :class="[
                  'sidebar-button items-start flex text-white mb-4 mx-auto p-2 cursor-pointer',
                  {
                    'rounded-[10px] text-[#64748b]': menu.isActive,
                    'justify-center': sidebarState.isCollapsed,
                  },
                ]"
              >
                <div class="sidebar-image flex-none">
                  <img
                    width="24"
                    height="24"
                    :src="menu.isActive ? menu.iconActive : menu.icon"
                    alt="Icon"
                  />
                </div>
                <div
                  v-if="!sidebarState.isCollapsed"
                  :class="[
                    'sidebar-text flex-1 line-clamp-1',
                    { 'text-[#64748b]': menu.isActive },
                  ]"
                  :title="menu.name"
                >
                  {{ menu.name }}
                </div>
                <img
                  v-if="!sidebarState.isCollapsed"
                  width="16"
                  height="16"
                  :src="
                    sidebarState.expandedMenus[index]
                      ? '/images/icons/ic-chevron-up-area-fill.svg'
                      : '/images/icons/ic-chevron-down-area-fill.svg'
                  "
                  alt="Icon"
                />
              </div>
              <div
                v-if="sidebarState.expandedMenus[index] && !sidebarState.isCollapsed"
                class="sidebar-submenu"
              >
                <div
                  v-for="(sub, index2) in menu.subMenu"
                  :key="`${index}-${index2}`"
                  :class="[
                    'button-box-submenu py-2',
                    {
                      'is-selected':
                        sub.activeNameList &&
                        sub.activeNameList.indexOf(
                          $router.currentRoute.value.name
                        ) >= 0,
                      'is-submenu-active':
                        sub.activeNameList &&
                        sub.activeNameList.indexOf(
                          $router.currentRoute.value.name
                        ) >= 0,
                    },
                  ]"
                  @click="sub.path && $router.push(sub.path)"
                >
                  <div :class="['sidebar-button-sub', {}]">
                    <div
                      :class="[
                        'sidebar-text flex-1',
                        {
                          'text-pink-active':
                            sub.activeNameList &&
                            sub.activeNameList.indexOf(
                              $router.currentRoute.value.name
                            ) >= 0,
                        },
                      ]"
                    >
                      {{ sub.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Toggle Button inside sidebar at bottom-right -->
    <div class="sidebar-footer" :class="{ 'w-full': !sidebarState.isCollapsed }">
      <button
        type="button"
        class="sidebar-toggle workflow-back-btn"
        @click="toggleSidebar"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          alt="Toggle"
          :class="{ 'rotate-180': sidebarState.isCollapsed }"
        >
          <path
            d="M10.5 4.5L6 9l4.5 4.5"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.6"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
const componentName = 'SidebarManagement';
// Props types: String, Number, Boolean, Array, Object, Function, Promise
const props = defineProps({
  className: {
    type: String,
  },
  inlineStyles: {
    type: Object,
    default: function () {},
  },
  menuList: {
    type: Array,
    default: [],
  },
  isShowLogo: {
    type: Boolean,
    default: true,
  },
  logoImage: {
    type: String,
    default: '/images/logos/logo-sidebar.png',
  },
  userImage: {
    type: String,
  },
  userName: {
    type: String,
  },
  heightItem: {
    type: Number,
  },
  heightItemUnit: {
    type: String,
  },
  onClickLogo: {
    type: Function,
    default: function () {},
  },
  onClickSubMenu: {
    type: Function,
    default: function () {},
  },
  isShowUsername: {
    type: Boolean,
    default: false,
  },
});


const { $router } = useNuxtApp();
console.log('router', $router.currentRoute.value);

const sidebarState = reactive({
  isCollapsed: false,
  expandedMenus: {}, // เก็บสถานะการเปิด/ปิดของแต่ละ menu
});

const toggleSidebar = () => {
  sidebarState.isCollapsed = !sidebarState.isCollapsed;
};

const toggleSubmenu = (menuIndex) => {
  if (!sidebarState.expandedMenus[menuIndex]) {
    // Close all other menus when opening a new one
    props.menuList.forEach((menu, index) => {
      if (menu.subMenu && index !== menuIndex) {
        sidebarState.expandedMenus[index] = false;
      }
    });
    sidebarState.expandedMenus[menuIndex] = true;
  } else {
    sidebarState.expandedMenus[menuIndex] = !sidebarState.expandedMenus[menuIndex];
  }
};

// Auto-expand menu ถ้า current route ตรงกับ submenu ใดๆ
// Close other menus when navigating to a different menu
const initializeExpandedMenus = () => {
  props.menuList.forEach((menu, menuIndex) => {
    if (menu.subMenu) {
      const hasActiveSubMenu = menu.subMenu.some(
        sub => sub.activeNameList && sub.activeNameList.indexOf($router.currentRoute.value.name) >= 0
      );
      if (hasActiveSubMenu) {
        sidebarState.expandedMenus[menuIndex] = true;
      } else {
        // Close submenu ถ้า current route ไม่ใช่ submenu ของ menu นี้
        sidebarState.expandedMenus[menuIndex] = false;
      }
    }
  });
};

onMounted(() => {
  initializeExpandedMenus();
});

// Watch route change
watch(() => $router.currentRoute.value.name, () => {
  initializeExpandedMenus();
});
</script>

<style lang="scss">
/* Component variables */
.sidebar-management-custom {
  /* Parent style   ------------------------------ */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 16.25rem;
  padding: 16px 17px;
  background-color: $color-base-white;
  height: 100vh;
  // border-right: 1px solid $color-secondary-2-s-200;
  // border-top-right-radius: 32px;
  // border-bottom-right-radius: 32px;
  // background: linear-gradient(180deg, #FFFFFF99 0%, #EFE1FF 100%);
  background: #FFFFFF99;

  
  transition: width 0.3s ease;
  position: relative;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      radial-gradient(ellipse 800px 600px at 15% 25%, rgba(255, 105, 180, 0.5) 0%, transparent 35%),
      radial-gradient(ellipse 600px 700px at 85% 20%, rgba(255, 200, 220, 0.3) 0%, transparent 40%),
      radial-gradient(ellipse 700px 600px at 75% 75%, rgba(100, 180, 255, 0.4) 0%, transparent 45%),
      radial-gradient(ellipse 500px 500px at 50% 50%, rgba(200, 150, 255, 0.2) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
    opacity: 0.4;
  }

  &.is-collapsed {
    width: 5rem;
  }

  /* Children style ------------------------------ */
  .sidebar-toggle {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;

    svg {
      transition: transform 0.3s ease;

      &.rotate-180 {
        transform: rotate(180deg);
      }
    }

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: scale(1.1);
    }
  }

  .sidebar-section {
    position: relative;
    z-index: 1;
    width: 100%;

    .is-logo {
      margin-bottom: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 140px;
        height: auto;
        // width: 32px;
        // height: 32px;
        // width: $size-v1sizing-8;
        // height: $size-v1sizing-8;
      }
    }

    .sidebar-lists {
      @include button-transition();
      overflow-y: auto;
      max-height: 70vh;
      min-height: 70vh;

      .button-box {
        /* height: 2.5rem; */
        height: 100%;
        border-radius: $semantic-dimension-cta-rounded-md;

        &.is-collapsed {
          .sidebar-button {
            justify-content: center;
            padding: 0.5rem;
          }
        }

        .sidebar-button {
          display: flex;
          gap: $space-x-2;
          padding: 0.5rem;
          align-items: center;
          margin: 0;
          transition: all 0.3s ease;

          &.justify-center {
            justify-content: center;
          }

          &.is-selected {
            /* background: #ffffff1a; */
            display: flex;
            align-items: center;
            justify-content: center;
            background: red;
          }

          .sidebar-image img {
            width: $semantic-dimension-icon-md;
            height: $semantic-dimension-icon-md;
          }

          .sidebar-image-sub img {
            width: $semantic-dimension-icon-sm;
            height: $semantic-dimension-icon-sm;
          }

          .rotate-img {
            transform: rotate(90deg);
          }

          .sidebar-text {
            font-family: $typography-font-family-primary;
            font-size: $semantic-text-body-md-font-size;
            font-weight: 500;
            line-height: $semantic-text-body-md-line-height;
            text-align: left;
            color: #734EB0;
          }
        }

        /* &.is-active {
          background: $specific-sidebar-navigation-background-active;
          &:hover {
            background: $specific-sidebar-navigation-background-active;
          }
        } */

        &.is-selected {
          cursor: default;
          background: #FFFFFFCC;
          border-radius: $semantic-dimension-cta-rounded-md;

          .sidebar-button {
            .sidebar-text {
              color: $specific-sidebar-navigation-foreground-selected;
            }
          }
        }

          &.is-submenu-selected {
            background: #FADEF5;
            border-radius: $semantic-dimension-cta-rounded-md;

            .sidebar-button  {
              background-color: #FFFFFFCC;
              border-radius: 999px;
              .sidebar-text {
                color: $specific-sidebar-navigation-foreground-selected;
              }
            }
          }

        &:hover {
          background: #FFFFFFCC;
          border-radius: $semantic-dimension-cta-rounded-md;
          .sidebar-button {
            .sidebar-text {
              color: $specific-sidebar-navigation-foreground-selected;
            }
          }
        }
      }
    }
  }

  .sidebar-submenu {
    background: #FADEF5;
    border-bottom-right-radius: $semantic-dimension-cta-rounded-md;
    border-bottom-left-radius: $semantic-dimension-cta-rounded-md;
    padding: 16px 0;

    .button-box-submenu {
      transition: all 0.3s ease;

      .sidebar-button-sub {
          .sidebar-text {
            color: $specific-sidebar-navigation-foreground-selected;
            padding-left: 28px;
          }
        }
      
      &.is-selected {
        background: linear-gradient(
          273.84deg,
          rgba(245, 241, 254, 0) -22.26%,
          rgba(255, 255, 255, 0.18) 48.1%
        );
        // background-color: #FADEF5;
        border-radius: $semantic-dimension-cta-rounded-md;

        .sidebar-button-sub {
          .sidebar-text {
            color: $specific-sidebar-navigation-foreground-selected;
          }
        }
      }

      &.is-submenu-active {
        background: #FFB5EE;
        border-radius: $semantic-dimension-cta-rounded-md;
        padding: 8px 12px;
        // margin: 0 8px;

        .sidebar-button-sub {
          .sidebar-text {
            color: #734EB0;
            font-weight: 700;
          }
        }
      }

      .text-pink-active {
        color: #734EB0;
        font-weight: 700;
      }
    }
  }

  .workflow-back-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    width: 36px;
    border-radius: 9999px;
    background: #f4f0ff;
    color: #5d45a5;
    transition: background 0.15s ease, transform 0.15s ease;
  }

  .sidebar-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 16px;
    margin-top: auto;
    position: relative;
    z-index: 1;
  }
}
</style>
